var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeAdd = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 23 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2.5A9.77 9.77 0 0 1 20.32 8a9.76 9.76 0 0 1-8.82 5.5A9.76 9.76 0 0 1 2.68 8a9.77 9.77 0 0 1 8.82-5.5m0-2C6.5.5 2.23 3.61.5 8c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5m0 5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5m0-2C9.02 3.5 7 5.52 7 8s2.02 4.5 4.5 4.5S16 10.48 16 8s-2.02-4.5-4.5-4.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 10)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M4 2.5v3M2.5 4h3"
  }))));
};
export default SvgEyeAdd;